import { render, staticRenderFns } from "./UserCoreRegister.vue?vue&type=template&id=f04fbd62"
import script from "./UserCoreRegister.vue?vue&type=script&lang=js"
export * from "./UserCoreRegister.vue?vue&type=script&lang=js"
import style0 from "./UserCoreRegister.vue?vue&type=style&index=0&id=f04fbd62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports